import { useState, useEffect } from "react";
/**
 * Prefer this hook over the Chakra UI useMediaQuery hook.
 * This hook takes in a media query and returns true or false if the media query
 * matches the current screen size. In addition, if we dont know if it matches (SSR)
 * it will return null. This gives us a third option to do something else if the media
 * query match is not yet known.
 * When using this, it is recommended that wherever you are test if !matches you first test matches !== null
 */
export function useMediaQuery(mediaQueryString) {
    var _a = useState(null), matches = _a[0], setMatches = _a[1];
    // matches will be null until first render when this useEffect triggers
    // Then we will set up listeners and immediately set matches to true/false
    useEffect(function () {
        var mediaQueryList = window.matchMedia(mediaQueryString);
        var listener = function () { return setMatches(mediaQueryList.matches); };
        mediaQueryList.addEventListener("change", listener);
        listener();
        return function () { return mediaQueryList.removeEventListener("change", listener); };
    }, [mediaQueryString]);
    return matches;
}
